import axios from "../../utilis/axios";

export const getReletedVideo = async ({ tags, id }) => {
  // console.log(id, tags);
  const limit = 5;
  let querySting =
    tags?.length > 0
      ? tags?.map((tag) => `tags_like=${tag}`).join("&") +
        `&id_ne=${id}&_limit=${limit}`
      : `id_ne=${id}&_limit=${limit}`;
  const res = await axios.get(`/videos?${querySting}`);
  return res.data;
};
